export const BloodGridPLTActions = {
    PLT_UPDATE_SIZE_RANGE:"PLT_UPDATE_SIZE_RANGE",
    PLT_UPDATE_EXTREME_SIZE_RANGE:"PLT_UPDATE_EXTREME_SIZE_RANGE",
    PLT_GRID_SELECTED:"PLT_GRID_SELECTED",
    PLT_CHANGE_IMAGE:"PLT_CHANGE_IMAGE",
    UPDATE_PAGE:"UPDATE_PAGE",
    UPDATE_PAGE_SIZE: "UPDATE_PAGE_SIZE",
    UPDATE_TOTAL_PAGES:"UPDATE_TOTAL_PAGES",
    UPDATE_TOTAL_COUNT:"UPDATE_TOTAL_COUNT",
    UPDATE_CURR_GRIDS: "UPDATE_CURR_GRIDS",
    SELECTED_GRID_OVERALL_ID: "SELECTED_GRID_OVERALL_ID",
    UPDATE_FETCHING_GRID:"UPDATE_FETCHING_GRID", 
} 